export default "__VITE_ASSET__CCw4GuAC__"